// Module
var code = "<div class=\"accounts-by-type\"><h3>Accounts by plan type</h3><div class=\"accounts-by-type-chart\"><svg></svg></div></div>\n";
// Exports
module.exports = code;